var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.UiSelectProxy,{attrs:{"placeholder":"Tax Rate","label":_setup.props.label,"options":_setup.taxRateOptions,"invalid":_setup.props.invalid,"error":_setup.props.error},model:{value:(_setup.internal),callback:function ($$v) {_setup.internal=$$v},expression:"internal"}})
}
var staticRenderFns = []

export { render, staticRenderFns }